<template>
  <div class='wrapper-page'>
    <modal ref="deleteFutureMessages" class="filter-all-messages">
      <template #header>
        <h5 class='modal-title mt-0'>
          {{ $t('communication.delete_messages')}}
        </h5>
      </template>
      <template #body>
        <form>
          <div class='modal-body'>
            <p>{{ $t('communication.are_you_sure_you_wanna_delete_future_messages')}}</p>
          </div>
          <div class='modal-footer'>
            <input type='reset' class='btn btn-outline-danger float-right' :value="$t('communication.delete_messages_button')" @click.prevent='deleteFutureMessages' />
          </div>
        </form>
      </template>
    </modal>
    <modal ref='filtersModal' class="filter-all-messages">
      <template #header>
        <h5 class='modal-title mt-0'>
          {{ $t('shared.filter') }}
        </h5>
      </template>

      <template #body>
        <form @submit.prevent='filterSentEmails'>
          <div class='modal-body'>
            <div class='form-group form-inline'>
              <label>{{ $t('folders_list.starred_folders')}}</label>
              <label>
                <input type='radio' v-model='starred' value='true'>
                {{ $t('folders_list.yes_way') }}
              </label>

              <label>
                <input type='radio' v-model='starred' value='false'>
                {{ $t('folders_list.no_way') }}
              </label>
              <label>
                <i class='fas fa-times' :title="$t('records_list.remove_selection')" @click.prevent='starred = null'></i>
              </label>
            </div>

            <div class="form-group">
              <label>{{ $t('communication.from') }}</label>
              <multi-select :getter="getUsers" v-model="fromUsersFilters" />
            </div>
            <div class="form-group">
              <label>{{ $t('communication.to') }}</label>
              <multi-select :getter="getContacts" v-model="toContactFilters" />
            </div>
            <div class="form-group">
              <label>{{ $t('communication.keywords') }}</label>
              <label>
                <input type="text" name="search" v-model="searchInFutureEmails" class="form-control">
              </label>
            </div>
            <div class="form-group">
              <label>{{ $t('communication.tags') }}</label>
              <multi-select :getter="getTags" v-model="tagsFilters" />
            </div>
            <div class="form-group">
              <label>{{ $t('communication.sending_date') }}</label>
              <div class="date">
                <label>{{ $t('communication.from') }}</label>
                <datepicker
                  ref="datepicker"
                  name="document_request[sending_date]"
                  v-model="fromFutureSendingDate"
                  input-class="form-control expiration-input"
                  :inline="false"
                  :typeable="true"
                  :full-month-name="true"
                  :monday-first="true"
                  :placeholder="$t('expiration.pick_date')">
                </datepicker>
              </div>
              <div class="date">
                <label>{{ $t('communication.to') }}</label>
                <datepicker
                  ref="datepicker"
                  name="document_request[sending_date]"
                  v-model="toFutureSendingDate"
                  input-class="form-control expiration-input"
                  :inline="false"
                  :typeable="true"
                  :full-month-name="true"
                  :monday-first="true"
                  @selected="this.$refs.datepicker.close()"
                  :placeholder="$t('expiration.pick_date')">
                </datepicker>
              </div>
            </div>
          </div>

          <div class='modal-footer'>
            <input type='reset' class='btn btn-neutral float-right' :value="$t('folders_list.clear_filters')" @click.prevent='resetFilters' />
            <input type='submit' class='btn btn-outline-primary float-right' :value="$t('folders_list.filter')" />
          </div>
        </form>
      </template>
    </modal>
    <div class='container-fluid text-center'>
      <h1 class='page-title'>
        {{ $t('communication.future_emails') }} ({{meta.total}})
        <a :href="futureVideo()" target="_blank" class="own-tooltip own-tooltip-bottom video-link" :data-tooltip="$t('communication.click_here_to_watch_future')"><img src="../../assets/video.svg" /></a>
      </h1>
      <div class="actions-on-table">
        <div class='filter'>
          <a  @click.prevent="openModal($refs.filtersModal)" href="#" class="filter-by btn btn-neutral">
            {{ $t('root.filter_all_data_by') }}
          </a>
        </div>
      </div>
      <div class="filter-results" v-if="filterMessages">
        <strong v-if="hasFilters">{{ $t('root.filter_results_for') }}</strong>
        <div v-if="starred !== null">
          <p>{{ $t('root.filters.starred') }}
            <strong v-if="starred === 'true'">{{ $t('root.filters.yes_way') }}</strong>
            <strong v-if="starred === 'false'">{{ $t('root.filters.no_way') }}</strong>
          </p>
        </div>
        <div v-if="fromUsersFilters.length > 0">
          <p>{{ $t('communication.filters.sending_date_from') }} <strong v-for="user in fromUsersFilters">{{user.name}}</strong></p>
        </div>
        <div v-if="toContactFilters.length > 0">
          <p>{{ $t('communication.filters.sending_date_to') }} <strong v-for="contact in toContactFilters">{{contact.name}}</strong></p>
        </div>
        <div v-if="searchInFutureEmails !== ''">
          <p>{{ $t('communication.filters.keywords') }} <strong>{{searchInFutureEmails}}</strong></p>
        </div>
        <div v-if="tagsFilters.length > 0">
          <p>{{ $t('communication.filters.tags') }} <strong v-for="tag in tagsFilters">{{tag.name}}</strong></p>
        </div>
        <div v-if="fromFutureSendingDate !== null">
          <p>{{ $t('communication.filters.receiving_date') }} <strong>{{ formatDate(fromFutureSendingDate) }}</strong></p>
        </div>
        <div v-if="toFutureSendingDate !== null">
          <p>{{ $t('communication.filters.until_date') }} <strong>{{ formatDate(toFutureSendingDate) }}</strong></p>
        </div>

        <a v-if="hasFilters" @click.prevent="resetFilters" href="#">{{ $t('records_list.clear_filters') }}</a>
      </div>
      <loading v-if="loading" />
      <div v-else-if='futureEmails.length === 0 && !loading' class="empty-list-wrapper">
        <img src="../../assets/empty_states/envelope.svg" />
        <p>{{$t('communication.future_empty_state')}}</p>
      </div>
      <div class="table_wrapper" v-else-if='futureEmails.length > 0 && !loading'>
        <div :class="['bulk-container', { 'hide': bulkOpMessages.length === 0  }]">
          <span>{{ bulkOpMessages.length }} {{ $t('root.futures_messages') }}</span>
          <ul>
            <li>
              <a @click.prevent="$refs.bulkTagMessages.open(null, bulkOpMessages, null, null, null)" class="dropdown-item" href="#">
                <i class="fas fa-tag"></i>
                {{ $t('communication.tags') }}
              </a>
              <bulk-tag-messages
                ref="bulkTagMessages"
                @success="addTagsToBulkMessages()">
              </bulk-tag-messages>
            </li>
            <li>
              <a @click.prevent='openDeleteMessageModal(bulkOpMessages)' class="dropdown-item" href="#" rel="nofollow">
                <i class="far fa-trash-alt"></i>
                {{ $t('communication.delete') }}
              </a>
            </li>
          </ul>
        </div>
        <table class="table">
          <thead>
          <tr>
            <th><input type='checkbox' @input='selectAll' /></th>
            <th></th>
            <th>{{ $t('communication.from')}}</th>
            <th>{{ $t('communication.to')}}</th>
            <th>{{ $t('communication.subject')}}</th>
            <th>{{ $t('communication.tags')}}</th>
            <th>{{ $t('communication.send_on')}}</th>
            <th>{{ $t('communication.status')}}</th>
            <th>{{ $t('communication.actions')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="message in futureEmails">
            <td class="bulk-check">
              <input type='checkbox' :value='message.id' v-model='bulkOpMessages' />
            </td>
            <td>
              <a href='#' class="starred" @click.prevent="starMessage(message)">
                <i :class="['fa-star', {'far': !message.starred, 'fas': message.starred }]"></i>
              </a>
            </td>
            <td>
              <router-link :to="{name: 'message', params: { id: message.id, referrer: $route.name, messageType: $route.name }}">
                {{ message.creator.full_name }}
              </router-link>
            </td>
            <td><router-link :to="{name: 'message', params: { id: message.id, referrer: $route.name, messageType: $route.name }}">
                {{ message.receiver.name }} - {{ message.receiver.email }}
              </router-link>
            </td>
            <td>
              <router-link :to="{name: 'message', params: { id: message.id, referrer: $route.name, messageType: $route.name }}" v-if="message.subject">
                {{ message.subject }}
              </router-link>
              <router-link :to="{name: 'message', params: { id: message.id, referrer: $route.name, messageType: $route.name }}" v-else>
                {{ $t('communication.no_subject')}}
              </router-link>
            </td>
            <td>
              <tag-manager
                resourceType="documentRequest"
                :resource='message'
                @reload-list="getFutureEmails()">
              </tag-manager>
              <div class="tag-dropdown-column">
                <div class="existing-tags-wrapper" :class="tag.color"
                     v-for="tag in message.tags">
                  <div class="btn-group btn-group-toggle" data-toggle="buttons">
                    <label class="btn active">
                      <router-link :to="{name: 'tag', params: { id: tag.id }}">
                        {{tag.name}}
                      </router-link>
                    </label>
                    <label class="btn" @click.prevent="removeConnectedTag(tag, message.id)">
                      <i class="fa fa-remove"></i>
                    </label>
                  </div>
                </div>
              </div>
            </td>
            <td>{{ formatDate(message.future_sending_at) }}</td>
            <td>
              <i :class="`fas fa-circle ${ statusClass(message.status) }`" />
              {{ statusText(message.status) }}
            </td>
            <td class="dropdown-column">
              <div class="dropdown">
                <button aria-expanded="false" aria-haspopup="true" data-toggle="dropdown" type="button" class="btn dropdown-toggle">· · ·</button>
                <div class="dropdown-menu dropdown-menu-right">
                  <ul>
                    <li>
                      <a @click.prevent='openDeleteMessageModal([message.id])' href="#" rel="nofollow" class="dropdown-item">
                        <i class="far fa-trash-alt"></i>
                        {{ $t('communication.delete')}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="empty-list-wrapper" v-else-if='futureEmails.length === 0 && !hasFilters'>
        <p>{{ $t('root.no_data') }}</p>
      </div>

      <div class="empty-list-wrapper" v-else-if='futureEmails.length === 0 && hasFilters'>
        <p>{{ $t('root.no_data_filters') }}</p>
        <a href="#" @click.prevent="$refs.filtersModal.reset">{{ $t('root.clear_filters') }}</a>
      </div>
      <pagination :meta='meta'/>
    </div>
  </div>
</template>

<script>
import _modal from '../../components/_modal'
import _pagination from "../../components/_pagination"
import _loading from '../../components/_loading'
import tag_manager from "../../components/tags/_tags_manager"
import _multi_select from "../../components/shared/_infinite_multi_select"
import Datepicker from 'vuejs-datepicker'
import bulk_tag_messages from "../../components/tags/_bulk_tag_messages"
export default {
  name: 'FutureEmails',
  components: {
    'multi-select': _multi_select,
    'modal': _modal,
    pagination: _pagination,
    'loading': _loading,
    'tag-manager': tag_manager,
    'datepicker': Datepicker,
    'bulk-tag-messages': bulk_tag_messages
  },
  data() {
    return {
      loading: true,
      bulkOpMessages: [],
      messageIds: [],
      fromUsersFilters: [],
      toContactFilters: [],
      tagsFilters: [],
      fromFutureSendingDate: null,
      toFutureSendingDate: null,
      searchInFutureEmails: '',
      starred: null,
    }
  },
  watch: {
    query() {
      this.getFutureEmails()
    }
  },
  created() {
    this.store.sendMetrics({name: 'scheduled_emails', params: this.$route.params, path: this.$route.fullPath})
    this.getFutureEmails()
  },
  computed: {
    futureEmails() {
      return this.state.futureEmails || []
    },
    contacts() {
      return this.lists.contacts || []
    },

    users() {
      return this.lists.users || []
    },

    tags() {
      return this.lists.tags || []
    },
  },
  methods: {
    getFutureEmails() {
      this.store.getFutureEmails(this.query).then(() =>  this.loading = false)
    },
    openModal(modal) {
      modal.open()
    },
    starMessage(message) {
      return this.store.updateDocumentRequest(message.id, { starred: !message.starred}).then(() => {
        this.store.sendMetrics({name: 'star_document_request', params: this.$route.params, path: this.$route.fullPath})
        this.getFutureEmails()
      })
    },
    removeConnectedTag(tag, documentRequestId) {
      this.store.sendMetrics({name: 'remove_tag_from_document_request', params: this.$route.params, path: this.$route.fullPath})
      this.store.removeConnectedTag(tag.id, { document_request_id: documentRequestId }).then(() => {
        this.getFutureEmails()
      })
    },
    filterMessages() {
      return this.toContactFilters.length > 0 || this.fromUsersFilters.length > 0 ||
        this.tagsFilters.length > 0 || this.fromFutureSendingDate !== null ||
        this.toFutureSendingDate !== null || this.searchInFutureEmails !== '' || this.starred !== null
    },
    getContacts(params) {
      return this.listStore.getContacts(params)
    },

    getUsers(params) {
      return this.listStore.getUsers(params)
    },
    getTags(params) {
      return this.listStore.getTags(params)
    },
    selectAll(e) {
      this.bulkOpMessages = e.target.checked ? this.futureEmails.map(i => i.id) : []
    },
    closeDatePicker() {
      this.$refs.datepicker.close()
    },
    filtersOn() {
      this.$refs.filtersModal.close()
    },
    resetFilters() {
      this.fromUsersFilters = []
      this.toContactFilters= []
      this.tagsFilters = []
      this.fromFutureSendingDate = null
      this.toFutureSendingDate = null
      this.searchInFutureEmails = ''
      this.starred = null
      this.$router.push({ query: null})
      this.$refs.filtersModal.close()
    },

    filterSentEmails() {
      let q  = {
        'filters[from]': this.fromUsersFilters.length > 0 ? this.fromUsersFilters.map(c => c.id) : null,
        'filters[to]': this.toContactFilters.length > 0 ? this.toContactFilters.map(c => c.id) : null,
        'filters[tags]': this.tagsFilters.length > 0 ? this.tagsFilters.map(c => c.id) : null,
        'filters[from_sending_date]': this.fromFutureSendingDate !== null ? this.formatDate(this.fromFutureSendingDate) : null,
        'filters[to_sending_date]': this.toFutureSendingDate !== null ? this.formatDate(this.toFutureSendingDate) : null,
        'filters[search_query]': this.searchInFutureEmails.length > 2 ? this.searchInFutureEmails : null,
        'filters[starred]': this.starred !== null ? this.starred : null,
        'page': this.query.page || 1
      }
      const f = Object.entries(q).reduce((a,[k,v]) => (v === null ? a : (a[k]= v, a)), {})

      this.$refs.filtersModal.close()
      this.$router.push({ query: f })
    },

    openDeleteMessageModal(messageIds) {
      this.messageIds = messageIds
      this.$refs.deleteFutureMessages.open()
    },
    deleteFutureMessages() {
      this.store.sendMetrics({name: 'delete_document_request', params: this.$route.params, path: this.$route.fullPath})
      this.$refs.deleteFutureMessages.close()
      this.store.deleteDocumentRequest(this.messageIds).then(() => {
        this.bulkOpMessages = []
        this.messageIds = []
        this.getFutureEmails()
      })
    },
    addTagsToBulkMessages() {
      this.store.sendMetrics({name: 'bulk_add_tag_to_document_request', params: this.$route.params, path: this.$route.fullPath})
      this.bulkOpMessages = []
      this.getFutureEmails()
    },
    futureVideo(){
      if(this.locale === 'de')
        return 'https://relatico.wistia.com/medias/kveyh793vm'
      return 'https://relatico.wistia.com/medias/5lunln27i5'
    }
  },
}
</script>

<style lang="sass" scoped>
.actions-on-table
  float: left
  width: 100%
.filter-all-messages
  form
    text-align: left
    label
      text-align: left
      display: block
    .form-group
      margin-bottom: 20px
      .date
        width: 47%
        display: inline-block
        margin-right: 10px
    .form-inline
      label
        width: 20%
        &:first-child
          width: 50%
        &:last-child
          width: 5%
          color: #686868
          cursor: pointer
.bulk-container
  background-color: #EBF4FE
  display: flex
  align-items: center
  padding: 8px 0
  border-radius: 3px
  float: left
  width: 100%
  > span
    padding-left: 10px
  ul
    list-style: none
    padding: 0
    margin: 0
    display: flex
    li
      position: relative
      a
        &:hover, &:visited, &:focus
          background: none
          text-decoration: underline
  &.hide
    display: none
</style>
